import React from 'react';
import {Row, Col, Card} from 'react-materialize';
import floating_equipment from "../../images/floating_equipment.png";
import cloths from "../../images/cloths.png";
import face_protection from "../../images/face_protection.png";
import hearing_protection from "../../images/hearing_protection.png";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Epi = () => (

    <Card>
        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>

                <div align="center">

                    <img src={floating_equipment} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"floating"} defaultMessage={"Equipamentos de flutuação"}/></b></p></h5>
                <br/>
                <p><b><FormattedMessage id={"lifejack"} defaultMessage={"Colete salva-vidas"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"floating.text"} defaultMessage={"O colete salva vidas deve permitir que a pessoa possa vesti-lo correta e rapidamente; ser confortável; resistente a diferentes tipos de água, temperaturas e avarias; ser dotado de um apito de material resistente à oxidação, firmemente preso ao colete."}/> </li>
                        <li><FormattedMessage id={"floating.text2"} defaultMessage={"O colete salva-vidas deve lever em consideração o peso e tamanho do usuário, para permitir uma flutuabilidade estável."}/></li>
                        <li><FormattedMessage id={"floating.text3"} defaultMessage={"Modelos com gola de formato e volume específicos são capazes de manter o rosto em distância segura da água ou desvirar a pessoa rapidamente em casos de inconsciência. Verificar modelos que possuem esta especificidade."}/></li>
                        <li><FormattedMessage id={"floating.text4"} defaultMessage={"Os coletes salva-vidas são classificados e devem ser utilizados de acordo com a forma e condições de uso."}/></li> </ul> </div>

                <p><b><FormattedMessage id={"buoys"} defaultMessage={"Bóias e linhas salva-vidas"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"buoys.text"} defaultMessage={"As bóias são dispositivos para águas calmas e interiores no qual a ajuda está sempre próxima. Não são seguras para pessoas inconscientes ou para longos períodos na água."}/></li>
                        <li><FormattedMessage id={"buoys.text2"} defaultMessage={"As linhas salva-vidas são usadas para resgate de pessoas na água ou para proteger contra quedas."}/></li> </ul> </div>
            </Col>
        </Row>

        <br/>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={cloths} className={"img"} /> </div>
            </Col>
            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"protectionc"} defaultMessage={"Roupas de proteção"}/></b></p></h5>
                <br/>
                <p><b><FormattedMessage id={"gloves"} defaultMessage={"Luvas"}/></b></p>

                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"gloves.text"} defaultMessage={"Luvas devem ser usadas ao manusear animais, produtos, facas, agulhas, produtos químicos e substâncias perigosas."}/></li>
                        <li><FormattedMessage id={"gloves.text2"} defaultMessage={"Use luvas de trabalho se estiver com lesões, escoriações ou irritações nas mãos e braços, exceto quando usá-las, puderem causar um risco."}/></li>
                        <li><FormattedMessage id={"gloves.text3"} defaultMessage={"Luvas de borracha podem fornecer proteção contra a umidade e o frio e são eficazes ao manusear equipamentos."}/></li>
                        <li><FormattedMessage id={"gloves.text4"} defaultMessage={"Luvas de tecido podem ser usadas por baixo para conforto inclusive térmico e luvas de rede de malha fornecem uma boa proteção quando se lida com equipamento ou engrenagem com bordas afiadas. Ao trabalhar perto de uma talha, lança, serra ou esteira, use luvas anti-corte, amarre o cabelo comprido e não use roupas soltas ou jóias."}/></li>
                    </ul></div>
                <p><b><FormattedMessage id={"shoes"} defaultMessage={"Calçados"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"shoes.text"} defaultMessage={"Use botas de segurança ou calçado com boa tração que evitem escorregões e quedas. Também ao operar veículas e máquinas."}/></li>
                    </ul></div>

                <p><b><FormattedMessage id={"overall"} defaultMessage={"Macacão"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"overall.text"} defaultMessage={"Use a roupa apropriada para a estação do ano e tarefa a ser realizada."}/></li>
                        <li><FormattedMessage id={"overall.text2"} defaultMessage={"As roupas devem proteger da exposição prolongada ao tempo frio, especialmente se as roupas estiverem encharcadas de água ou por imersão direta, que pode resultar em hipotermia, confusão mental e muscular e morte."}/></li>
                    </ul></div>
                <p><b><FormattedMessage id={"hats"} defaultMessage={"Chapéus e proteção solar"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"hats.text"} defaultMessage={"Os trabalhadores devem usar um chapéu que mantenha a luz solar direta longe de sua cabeça, orelhas e rosto."}/></li>
                        <li><FormattedMessage id={"hats.text2"} defaultMessage={"Devem estar protegidos da luz direta do sol e raios ultra-violetas usando bloqueador solar."}/></li>
                    </ul></div>
                <p><b><FormattedMessage id={"wetsuit"} defaultMessage={"Roupa de mergulho/equipamentos de mergulho"}/></b></p>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"wetsuit.text"} defaultMessage={"Cada mergulhador deve estar equipado com uma faca forte e afiada; pesos com um mecanismo de liberação rápida que são suficientes para controlar a flutuabilidade; um traje de mergulho ou outra roupa protetora; e proteção adequada da cabeça durante a condução de um mergulho, que expõe o mergulhador a riscos de queda de objetos ou ferimentos na cabeça."}/></li>
                    </ul></div></Col>
        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={face_protection} className={"img"}/> </div>
            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"eyes"} defaultMessage={"Olhos"}/></b></p></h5>
                <br/>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"eyes.text"} defaultMessage={"Proteja os olhos com óculos de segurança ou óculos de proteção quando a atividade requer proteção para os olhos."}/></li>
                        <li><FormattedMessage id={"eyes.text2"} defaultMessage={"Os trabalhadores devem usar óculos de sol para proteger os olhos da luz direta do sol ou do reflexo da água ou do gelo."}/></li>
                        <li><FormattedMessage id={"eyes.text3"} defaultMessage={"Não use óculos de sol padrão como substituto de óculos de segurança ao realizar tarefas que exijam o uso de proteção para os olhos. Para estas tarefas, utilize óculos ou máscaras de proteção adequadas."}/></li> </ul> </div>
            </Col>
        </Row>


        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={hearing_protection} className={"img"}/> </div>
            </Col>

            <Col s={10} m={10}>
                <h5> <p><b><FormattedMessage id={"hearing"} defaultMessage={"Proteção auditiva"}/></b></p> </h5>
                <br/>
                <div align="justify">
                    <ul className={"browser-default"}>
                        <li><FormattedMessage id={"hear.text"} defaultMessage={"Use proteção auditiva (protetores, abafadores e plugues auriculares) ao usar equipamentos ou máquinas barulhentas (se o nível de ruído exceder 85 decibéis). Uma boa regra é se outra pessoa estiver falando e não puder ser ouvida quando estiver a uma distância do braço, então a proteção auditiva deve ser usada."}/></li>
                        <li><FormattedMessage id={"hear.text2"} defaultMessage={"Alguns dos equipamentos mais comuns usados pelos aquicultores onde a proteção auditiva deve ser usada incluem uma motossera (115 decibéis), um motor a gasolina (100 decibéis), trator (80-110 decibéis0, máquinas de lavar ostras (>80 decibéis)."}/></li> </ul> </div>
            </Col>
        </Row>

    </Card>

);

export default Epi;